import React, { PropsWithChildren } from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import solvTheme from '../themes/defaultTheme';

// Creating this HOC to wrap Solv Design System (SDS) components.
// Ideally this would be at the root <App /> component so this wouldn't be necessary, but we only want this
// theming to be used for new components so that we don't mess up styles for existing material ui components being used elsewhere.
export default <Props extends {}>(Component: React.ComponentType<Props>, theme: any = solvTheme) =>
  (props: PropsWithChildren<Props>) =>
    (
      <MuiThemeProvider theme={theme}>
        <Component {...props} />
      </MuiThemeProvider>
    );
